import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { Review } from '../utils/reviewsData';
interface ReviewsSectionProps {
  reviews: Review[];
  title?: string;
  subtitle?: string;
  sectionLabel?: string;
  disclaimerText?: string;
}
export function ReviewsSection({
  reviews,
  title = 'Real Results From Real Men',
  subtitle = 'Verified customers who committed to the protocol and documented their progress.',
  sectionLabel = 'Customer Reviews',
  disclaimerText = 'All reviews are from verified customers who purchased CrownControl™ and followed the recommended protocol.'
}: ReviewsSectionProps) {
  return <section className="w-full bg-white py-20 px-4" data-id="element-235">
      <div className="max-w-7xl mx-auto" data-id="element-236">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-237">
          {/* Section Label */}
          <p className="text-brand-red font-semibold text-sm uppercase tracking-wider mb-4 text-center" data-id="element-238">
            {sectionLabel}
          </p>

          {/* Headline */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-239">
            {title}
          </h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto" data-id="element-240">
            {subtitle}
          </p>

          {/* Reviews Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-241">
            {reviews.map((review, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200" data-id="element-242">
                {/* Before/After Image */}
                <div className="bg-white p-4" data-id="element-243">
                  <img src={review.image} alt={`${review.name} before and after results`} className="w-full h-auto rounded-lg" data-id="element-244" />
                </div>

                {/* Review Content */}
                <div className="p-6" data-id="element-245">
                  {/* Star Rating */}
                  <div className="flex gap-1 mb-3" data-id="element-246">
                    {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-brand-red text-brand-red" aria-hidden="true" data-id="element-247" />)}
                  </div>

                  {/* Review Text */}
                  <p className="text-gray-700 leading-relaxed mb-4 italic" data-id="element-248">
                    "{review.review}"
                  </p>

                  {/* Customer Info */}
                  <div className="border-t border-gray-200 pt-4" data-id="element-249">
                    <p className="text-gray-900 font-semibold" data-id="element-250">
                      {review.name}, {review.age}
                    </p>
                    <p className="text-gray-600 text-sm" data-id="element-251">{review.location}</p>
                    <p className="text-brand-red text-sm font-medium mt-1" data-id="element-252">
                      Results after {review.timeline}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* Bottom Trust Statement */}
          <div className="mt-12 text-center" data-id="element-253">
            <p className="text-gray-600 text-sm" data-id="element-254">{disclaimerText}</p>
          </div>
        </motion.div>
      </div>
    </section>;
}